import { format, isValid, parse } from 'date-fns';
import { ALL_DATE_FORMATS, MONTH_DAY_YEAR_SLASHED_FORMAT } from './constants';

export type DateInput = string | number;

/**
 * Formats a date to the MM/dd/yyyy format
 * @param date - The date to format
 * @returns The formatted date (string) or the original date
 * (either string or number) if it cannot be formatted.
 */
const slashFormat = (date: DateInput): string => {
  let tmpDate = date as string;

  // The function might be used to handle Unix timestamps (which are numbers)
  if (typeof date === 'number') {
    tmpDate = date.toString();
  }

  // Find the first format that successfully parses the date
  const parsedDate = ALL_DATE_FORMATS.map(
    fmt => parse(tmpDate, fmt, new Date())
  ).find(parsed => isValid(parsed));

  // If a valid date is found, format it to MM/dd/yyyy
  if (parsedDate) {
    return format(parsedDate, MONTH_DAY_YEAR_SLASHED_FORMAT);
  }

  // If none of the formats match, return the input date
  return tmpDate;
};

export default slashFormat;
